export default "__VITE_ASSET__CTxr4sH$__"